import { type ActivationKey } from "../../license-lookup/license-lookup.types";
import { axiosGet } from "./axios-utility"

export const fetchLicense = async (serial: string): Promise<ActivationKey> => {
    const res = await axiosGet('/license_lookup?serial=' + serial.trim());
    const data: ActivationKey = res.data;
    return data;
}